module.exports = __webpack_public_path__ + "media/images/pic/teachers/urszula-hellich-f1f631d00e48b75dd16193dbd7e58a64.png";